import React from "react";

const UserPaymentFailed = () => {
  return (
    <div
      style={{
        minHeight: "320px",
        maxHeight: "500px",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(180deg, rgba(255,235,238,0.75) 0%, rgba(255,255,255,1) 100%)",
        padding: "20px",
        direction: "rtl",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "520px",
          maxHeight: "460px",
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
          padding: "28px 22px",
          textAlign: "center",
          border: "1px solid #ffebee",
        }}
      >
        <div style={{ fontSize: "50px", lineHeight: 1, marginBottom: "12px" }}>
          ❌
        </div>
        <h2 style={{ margin: "0 0 10px 0", color: "#b71c1c" }}>
          התשלום נכשל
        </h2>
        <p style={{ margin: 0, color: "#37474f", lineHeight: 1.7 }}>
          נראה שהתשלום לא הושלם.
          <br />
          אפשר לנסות שוב או לפנות לתמיכה אם הבעיה ממשיכה.
        </p>
      </div>
    </div>
  );
};

export default UserPaymentFailed;
